import { withGateOverride } from 'products-ui-components/utils/withGateOverride';
export function isUngated(auth, gate) {
  const hasGateInternal = !!(auth !== null && auth !== void 0 && auth.gates.includes(gate));
  return withGateOverride(gate, hasGateInternal);
}